package one.healthium.pilates.ui.workouts.components

import androidx.compose.foundation.Image
import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.layout.ContentScale
import androidx.compose.ui.unit.dp
import ifaandroid.apps.pilates.composeapp.generated.resources.Res
import ifaandroid.apps.pilates.composeapp.generated.resources.bg_meal_plan_card
import one.healthium.loco.resolve
import one.healthium.meal_plans.domain.MealPlanInfoModel
import one.healthium.ui.compose.theme.AppTheme
import org.jetbrains.compose.resources.painterResource

@Composable
fun MealPlanInfoCard(
    modifier: Modifier = Modifier,
    mealPlan: MealPlanInfoModel,
    onClick: () -> Unit
) {
    Box(
        modifier = modifier
            .fillMaxWidth()
            .padding(horizontal = 12.dp, vertical = 6.dp)
            .height(130.dp)
            .background(AppTheme.colors.primary, AppTheme.shapes.medium)
            .clip(AppTheme.shapes.medium)
            .clickable { onClick() }
    ) {
        Image(
            modifier = Modifier.fillMaxSize(),
            painter = painterResource(Res.drawable.bg_meal_plan_card),
            contentScale = ContentScale.Crop,
            contentDescription = null,
        )

        Text(
            modifier = Modifier.padding(horizontal = 20.dp, vertical = 30.dp),
            text = mealPlan.name.resolve(),
            style = AppTheme.contentCardStyle?.titleStyle ?: AppTheme.textStyles.poppins20,
            color = AppTheme.colors.textInverted100,
        )
    }
}